export class PortaleWebDTO {
  url: string;
}
